/**
 * Formats a Swiss phone number if valid, or returns the original string if invalid.
 * Handles `null`, `undefined`, or non-string inputs by returning an empty string.
 *
 * Swiss phone numbers must:
 * - Start with the country code `+41`.
 * - Contain exactly 12 characters (including `+` and digits).
 * - Be formatted as: `+41 XX XXX XX XX` (e.g., +41 79 123 45 67).
 *
 * @param phoneNumber - The phone number to format.
 * @returns - The formatted phone number, the original string if invalid, or an empty string for null/undefined inputs.
 */
export const formatSwissPhoneNumber = (phoneNumber: string | null | undefined): string => {
  if (!phoneNumber || typeof phoneNumber !== 'string') {
    return '';
  }

  if (!phoneNumber.startsWith('+41')) {
    return phoneNumber;
  }

  const cleaned = phoneNumber.replace(/[^\d+]/g, '');
  if (cleaned.length !== 12) {
    return phoneNumber;
  }

  const formatted = cleaned.replace(/^(\+41)(\d{2})(\d{3})(\d{2})(\d{2})$/, '$1 $2 $3 $4 $5');
  return formatted || phoneNumber;
};
